import { defineMessage } from 'react-intl';

const calendarLabel = defineMessage({
  defaultMessage: 'Kalenteri',
})
const jumpToPrevMonth = defineMessage({
  defaultMessage: 'Edellinen kuukausi',
})
const jumpToNextMonth = defineMessage({
  defaultMessage: 'Seuraava kuukausi',
})
export const DateRangePickerPhrases = {
  calendarLabel,
  jumpToPrevMonth,
  jumpToNextMonth,
}
